import { render, staticRenderFns } from "./announcement-column.vue?vue&type=template&id=7a8e40cf&"
import script from "./announcement-column.vue?vue&type=script&lang=js&"
export * from "./announcement-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports